import Feature from './Feature';
import Hero from './Hero';
import Image from './Image';
import Link from './Link';
import Block from './Block';
import Subpages from './Subpages';
import Credits from './Credits';
import Gallery from './Gallery';
import FilmCredits from './FilmCredits';
import FilmMaterials from './FilmMaterials';

export {
    Feature,
    Hero,
    Image,
    Link,
    Block,
    Subpages,
    Credits,
    Gallery,
    FilmCredits,
    FilmMaterials,
};

export default {
    Feature,
    Hero,
    Image,
    Link,
    Block,
    Subpages,
    Credits,
    Gallery,
};



// WEBPACK FOOTER //
// ./components/partials/index.js